import React, {Fragment,Component} from "react";
import axios from "axios";
import exportToExcel from "../utils/ExcelUtils";

class NAB_PolicyNewRow extends Component{
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            apiDetail: '/api/bankportal/report/detail/new/nab',
            reportName: 'NAB_ReportNew',
        }
        this.onCLickToExport = this.onCLickToExport.bind(this);
        this.exportToExcel = exportToExcel.bind(this);
        this.handlerClickNode = this.props.handlerClickNode.bind(this);
        this.handlerSetIsLoading = this.props.handlerSetIsLoading.bind(this);
    }

    componentDidMount() {

    }

    onCLickToExport = (item) => {
        const payload = {
            yyyymmdd: item?.yyyymmdd,
            code: item?.code,
            type: item?.type,
            parentId: item?.parentId
        }
        const { apiDetail, reportName } = this.state;
        this.handlerSetIsLoading(true);
        axios.post(apiDetail, payload)
            .then(response => {
                let data = [];
                if(!!response.data){
                    data.push([
                        "Ngày báo cáo"
                        ,"Số hợp đồng"
                        ,"Mã sản phẩm"
                        ,"Tên sản phẩm"
                        ,"Tình trạng hợp đồng"
                        ,"Tên tình trạng hợp đồng"
                        ,"Loại sản phẩm"
                        ,"Số tiền bảo hiểm"
                        ,"IP"
                        ,"Kỳ đóng phí"
                        ,"FYP"
                        ,"Nộp trong tháng"
                        ,"Ngày nộp"
                        ,"Ngày phát hành"
                        ,"Ngày tái phát hành"
                        ,"Ngày hủy"
                        ,"Ngày ký nhận thư"
                        ,"Thời hạn HĐBH"
                        ,"Thời hạn đóng phí"
                        ,"Tên khách hàng"
                        ,"Giới tính"
                        ,"CMND/Passport"
                        ,"Độ tuổi khách hàng"
                        ,"Nghề nghiệp khách hàng"
                        ,"Mã FSC"
                        ,"Tên FSC"
                        ,"Mã NVNH (FWD)"
                        ,"Mã CBNV (Ngân hàng)"
                        ,"Tên NVNH"
                        ,"Mã phòng giao dịch (FWD)"
                        ,"Mã phòng giao dịch (Ngân hàng)"
                        ,"Tên phòng giao dịch"
                        ,"Mã chi nhánh (FWD)"
                        ,"Mã chi nhánh (Ngân hàng)"
                        ,"Tên chi nhánh"
                        ,"Mã miền"
                        ,"Tên miền"
                        ,"Ngày ACK+21"
                        ,"Nguồn khách hàng từ NVNH giới thiệu"
                        ,"Mã người giới thiệu"
                        ,"Mã lãnh đạo phòng"
                        ,"CBNV ngân hàng"
                    ]);
                    response?.data.map(item =>
                        data.push([
                            item?.reportDate
                            ,item?.policyNumber
                            ,item?.productCode
                            ,item?.productName
                            ,item?.statusCode
                            ,item?.statusName
                            ,item?.productType
                            ,item?.sa
                            ,item?.ip
                            ,item?.premiumMode
                            ,item?.fyp
                            ,item?.pendingReason
                            ,item?.submitDate
                            ,item?.firstIssueDate
                            ,item?.issueDate
                            ,item?.cancelDate
                            ,item?.ackDate
                            ,item?.policyTerm
                            ,item?.premiumTerm
                            ,item?.poName
                            ,item?.poGender
                            ,item?.poId
                            ,item?.ageIssued
                            ,item?.jobName
                            ,item?.fscCode
                            ,item?.fscName
                            ,item?.bsCode
                            ,item?.bsCodeBank
                            ,item?.bsName
                            ,item?.toCode
                            ,item?.toCodeBank
                            ,item?.toName
                            ,item?.boCode
                            ,item?.boCodeBank
                            ,item?.boName
                            ,item?.regionCode
                            ,item?.regionName
                            ,item?.passAckDate
                            ,item?.leadSource
                            ,item?.introducerHrm
                            ,item?.hrm
                            ,item?.bsSell
                        ])
                    )
                }

                const exportName = item?.yyyymmdd+'_'+item?.code+'_'+item?.name+'_'+reportName;
                this.exportToExcel(data, exportName);
                this.handlerSetIsLoading(false);
            })
            .catch(error => {
                this.setState({ errorMessage: error.message });
                console.error('There was an error!', error);
                this.handlerSetIsLoading(false);
            });
    }
    render() {
        const {hasChild,isExpanded,marginLeftValue,data} = this.props;
        const iconStyle = {
            marginLeft: marginLeftValue+'px',
            boxShadow: 'none'
        }
        return (
            <Fragment>
            {
                !!data &&
                    <tr>
                        <td className={'bp-report-tree-node'}>
                            <button style={iconStyle} type="button" className={"btn"} onClick={this.handlerClickNode}>
                                {
                                    hasChild ?isExpanded?(' - '):(' + '):('   ')
                                }
                            </button>
                            <span>{ data?.name }</span>
                        </td>
                        <td className={"bp-report-td"}><span> { data?.c_refer?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_sub?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.p_sub?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_issued?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.p_issued?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_refer_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_meet_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_advisor_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_sub_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.p_sub_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_issued_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.p_issued_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_pending_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.p_pending_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_cancel_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.p_cancel_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_nt_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.p_nt_mtd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.c_issued_ytd?.toLocaleString() } </span></td>
                        <td className={"bp-report-td"}><span> { data?.p_issued_ytd?.toLocaleString() } </span></td>
                        <td className={'bp-report-button-export'}>
                            <button onClick={ () => this.onCLickToExport(data) } className={"btn btn-sm btn-info mt-1"}>Chi tiết</button>
                        </td>
                    </tr>

            }
            </Fragment>
        )
    }
}
export default NAB_PolicyNewRow;